export default __webpack_public_path__ + "static/media/complementary--bicycles-or-pedestrians-detour--g1.e5138d21.png";